export const LocalTempIdPrefix = "LOCALTID";
export class LocalIdGenerator {
    /**
     * Generate a new locally unique Id for the client's temporary use
     */ static generate() {
        LocalIdGenerator.counter++;
        return LocalTempIdPrefix + LocalIdGenerator.counter.toString();
    }
    /**
     * Check if the given id is a temporary id generated in the client
     * @param id Id to be checked
     */ static isLocalTempId(id) {
        if (id == null) {
            return false;
        }
        return id.indexOf(LocalTempIdPrefix) > -1;
    }
    /**
     * Generate a new GUID-like string
     * This is not a true GUID, but has the same format. It is used to create a deterministic
     * sequence of unique ids for testing purposes.
     */ static generateGuid() {
        LocalIdGenerator.counter++;
        const id = LocalIdGenerator.counter.toString();
        return `${id.padStart(8, "0")}-0000-0000-0000-${id.padStart(12, "0")}`;
    }
    /**
     * This method exists for the unit tests so that they can test id generation
     * Don't call this unless it's for a test!
     */ static resetCounterOnlyForTest() {
        LocalIdGenerator.counter = 0;
    }
}
LocalIdGenerator.counter = 0;
